import { render } from "./PageEditorViewBody.vue?vue&type=template&id=752cef11"
import script from "./PageEditorViewBody.vue?vue&type=script&lang=js"
export * from "./PageEditorViewBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__